export default __webpack_public_path__ + "static/media/mascota-parisR.cda71864.png";